export default "__VITE_ASSET__BQXSwQm5__"